import * as Types from '../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SaveJobMutationVariables = Types.Exact<{
  jobKey: Types.Scalars['ID']['input'];
  state: Types.SavedJobState;
}>;


export type SaveJobMutation = { __typename?: 'Mutation', updateSavedJobState?: { __typename?: 'UpdateSavedJobStatePayload', savedJob: { __typename?: 'SavedJob', job: { __typename?: 'Job', key: string } } } | null };


export const SaveJobDocument = gql`
    mutation saveJob($jobKey: ID!, $state: SavedJobState!) {
  updateSavedJobState(input: {jobKey: $jobKey, state: $state}) {
    savedJob {
      job {
        key
      }
    }
  }
}
    `;
export type SaveJobMutationFn = Apollo.MutationFunction<SaveJobMutation, SaveJobMutationVariables>;

/**
 * __useSaveJobMutation__
 *
 * To run a mutation, you first call `useSaveJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveJobMutation, { data, loading, error }] = useSaveJobMutation({
 *   variables: {
 *      jobKey: // value for 'jobKey'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useSaveJobMutation(baseOptions?: Apollo.MutationHookOptions<SaveJobMutation, SaveJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveJobMutation, SaveJobMutationVariables>(SaveJobDocument, options);
      }
export type SaveJobMutationHookResult = ReturnType<typeof useSaveJobMutation>;
export type SaveJobMutationResult = Apollo.MutationResult<SaveJobMutation>;
export type SaveJobMutationOptions = Apollo.BaseMutationOptions<SaveJobMutation, SaveJobMutationVariables>;